import { List, Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import ClientAccountsApiClient from '../../ApiClients/ClientAccountApiClient';
import ClientAccount from '../Models/ClientAccount';
import CurrencyComponentVM from '../../../Common/Components/Currency/CurrencyComponentVM';
import CreateClientAccountMappingCommand from '../Models/CreateClientCommand';
import StaticServiceProviderModel from '../../../Common/Models/StaticServiceProviderModel';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import UpdateClientCommand from '../Models/UpdateClientCommand';
import ClientEntityTypeLookup from '../Models/ClientEntityTypeLookup';
import ClientLookup from '../Models/ClientLookup';
import { StaticDataTypes } from '../../../Maintenance/StaticData/StaticDataTypes';

@NeoModel
export default class ManageClientAccountMappingVM extends Views.ViewModelBase {

    constructor(
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public clientAccountApiClient = AppService.get(Types.ApiClients.ClientAccountApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public taskRunner = AppService.get(Types.Neo.TaskRunner),
        private staticDataCache = AppService.get(StaticDataTypes.Services.StaticDataCache)) {
        super(taskRunner);
    }

    public switchProperty: boolean = true;
    public staticServiceProviderID: number = 0;
    public fileGroupingId: number = 0;
    public missingAccountId: number | null = null;
    public clientAccountNumber: string = "";
    public serviceProviderList = new List(StaticServiceProviderModel);
    public brokerList = new List(StaticServiceProviderFileGroupingModel);
    public selectedBroker = new StaticServiceProviderFileGroupingModel();
    public clientEntityTypeList = new List(ClientEntityTypeLookup);
    public selectedCurrrencyId: number = 0;
    public isFieldReadOnlyInd: boolean = false;
    public missingAccountsReadOnlyInd: boolean = false;
    public clientAccountModel = new ClientAccount();
    public apiClient = new ClientAccountsApiClient();
    public currencyComponentVM = new CurrencyComponentVM();
    public managedClientAccountLookup = new ClientAccount();
    public createClientAccountMappingCommand = new CreateClientAccountMappingCommand();
    public editClientCommand = new UpdateClientCommand();

    public clientAccounts: Model.PlainObject<ClientLookup>[] = [];
    public filteredClientAccounts: Model.PlainObject<ClientLookup>[] = [];   

    public async initialise() {
        await this.populateStockBrokerDropDownList();
        await this.populateCurrenciesDropDownList();
        await this.populateClientAccounts();   
       
        if (this.clientAccountModel.staticServiceProviderFileGroupingId !== null && this.clientAccountModel.staticServiceProviderFileGroupingId > 0) {
            this.fileGroupingId = this.clientAccountModel.staticServiceProviderFileGroupingId;
            this.setSelectedServiceProvider();
            this.populateStockbrokerCodeField();
        }

        if (this.clientAccountModel.staticCurrencyId > 0)
        {
            this.currencyComponentVM.selectedCurrency.staticCurrencyId = this.clientAccountModel.staticCurrencyId;
        }
    }

    public async setExistingClientAccountFields(clientNumber: string) {
        if (clientNumber.includes(" ")) {
            clientNumber = clientNumber.split(" ")[0];
        }
        this.isFieldReadOnlyInd = true;
        this.currencyComponentVM.isReadOnly = true;
        this.clientAccountModel.clientNumber = clientNumber;
        let client = this.clientAccounts.find(i => i.clientNumber === clientNumber);
        this.clientAccountModel.clientName = client?.clientName || '';
        this.currencyComponentVM.selectedCurrency.currencyCode = client?.currencyCode!;
        this.currencyComponentVM.selectedCurrency.staticCurrencyId = client?.staticCurrencyId!;
        this.clientAccountModel.staticCurrencyId = client?.staticCurrencyId!;
        this.clientAccountModel.clientEntityTypeId = client?.clientEntityTypeId!;
        this.clientAccountModel.clientEntityTypeName = client?.clientEntityTypeName!;
        this.setSelectedServiceProvider();
    }

    public async populateCurrenciesDropDownList() {
        this.currencyComponentVM.getCurrenciesList();
    }

    public async populateClientAccounts() {
        this.clientAccounts = await this.staticDataCache.clientAccounts.getDataAsync()
            .then((arr) => arr.sort((x, y) => x.clientDescription.localeCompare(y.clientDescription)));
        this.filteredClientAccounts = this.clientAccounts.slice(0, 10);
    }

    public async populateStockBrokerDropDownList() {
        var result = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.brokerList.set(result.data);
    }

    public clearPopulatedFields() {
        if (!this.clientAccountModel.existingClient) {
            this.currencyComponentVM.isReadOnly = false;
            this.isFieldReadOnlyInd = false;
        }
    }

    private mapCreateClientAccountMappingCommand() {
        this.createClientAccountMappingCommand.mapFrom(this.clientAccountModel);
        this.createClientAccountMappingCommand.isMappedFromMissingAccounts = this.missingAccountId !== 0;
        this.createClientAccountMappingCommand.staticCurrencyId = this.currencyComponentVM.selectedCurrency.staticCurrencyId;
        this.createClientAccountMappingCommand.missingAccountId = this.missingAccountId ?? 0;
        this.createClientAccountMappingCommand.staticServiceProviderFileGroupingId = this.selectedBroker.staticServiceProviderFileGroupingId;
    }

    private mapEditClientCommand() {
        this.editClientCommand.mapFrom(this.clientAccountModel);
    }

    public setSelectedServiceProvider() {
        if (this.fileGroupingId > 0) {
            this.clientAccountModel.meta.staticServiceProviderFileGroupingId.value = Number(this.fileGroupingId);
            this.clientAccountModel.meta.stockbrokerName.value = this.brokerList.find(i => i.staticServiceProviderFileGroupingId === Number(this.fileGroupingId))!.serviceProviderGroupingName;
            this.selectedBroker.staticServiceProviderFileGroupingId = Number(this.fileGroupingId);
        }
    }

    public populateStockbrokerCodeField() {
        if ((this.clientAccountModel.clientAccountId === null || this.clientAccountModel.clientAccountId === undefined) && this.selectedBroker.staticServiceProviderFileGroupingId != null && this.selectedBroker.staticServiceProviderFileGroupingId > 0) {
            
            var fileGrouping = this.brokerList.find(i => i.staticServiceProviderFileGroupingId === this.selectedBroker.staticServiceProviderFileGroupingId)
            if (fileGrouping !== null)
            {
                this.clientAccountModel.meta.brokerDescription.value = fileGrouping?.serviceProviderGroupingName!;
            }
        }
    }
}